import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchUserFavoriteRunners } from "../utils/userFavoriteUtils";
import { setUserFavoriteRunners } from "../store/actions";

const useSetUserFavoriteRunners = (accountId: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (accountId) {
      fetchUserFavoriteRunners(accountId).then((res: string[]) => {
        dispatch(setUserFavoriteRunners(res));
      });
    }
  }, [accountId]);
};

export default useSetUserFavoriteRunners;
